/** Provides rxjs/webSocket functionality in a way it can be easily injected and used throughout the application */

export { webSocket, WebSocketSubject } from 'rxjs/webSocket';
export { WEBSOCKET_FACTORY } from './web-socket-factory.injection-token';
